import { mapObjIndexed, compose } from 'ramda';

export const namespaceAction = ns => action => `${ns}_${action}`;
export const namespaceActionObject = compose(mapObjIndexed, namespaceAction);


// WEBPACK FOOTER //
// ./src/reducers/helpers.js